import React, { useEffect, useState, createContext, useMemo } from "react";
import {
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBSpinner,
  MDBBtn,
  MDBModalFooter,
  MDBAlert,
  MDBIcon,
} from "mdb-react-ui-kit";
import provisioningHelper from "./provisioning_helper.js";
import { AutoDeviceButtonContext } from "./AutoDeviceButtonContext.js";
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import {
  LoadHeaderTemplate,
  LoadMLATemplate,
  LoadParkTemplate,
  LoadSpeedDialTemplate,
  LoadBlankTemplate,
  LoadBLFTemplate,
} from "./AutoDeviceButtonTeamplates.js";
import PopupLoader from "../../../views/popups/PopupLoader";
import { useTranslation } from "react-i18next";

import { LoadBLFGroupsTemplate } from "./BlfGroupsTemplate.js";

import { dir } from "i18next";
import SaveChanges from "../saveCancel.js";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default function AutoDeviceButtons(props) {
  const [buttonTypes, setButtonTypes] = useState([]);
  const [pbxUsersList, setPBXUserList] = useState([]);
  const [telephonyUsersList, setTelephonyUsersList] = useState([]);
  const [linesDBData, setLinesDBData] = useState([]);
  const [linesDBMap, setLinesDBMap] = useState(new Map());
  const [loading, setLoading] = useState(false);
  const [blf_groups, setBlf_groups] = useState({});
  const [loadPopup, setLoadPopup] = useState({});
  const { t, i18n } = useTranslation();
  const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");
  const [updateFailureMessage, setUpdateFailureMessage] = useState(false);

  const [cancelChanges,setCancelChanges] = useState(false)
  const [defaultMla,setDefaultMla]=useState(null)
  const [defaultRingType,setDefaultRingType]=useState(null)
  const [blfPopUpAlert,setBlfPopAlert]=useState(false)
  const [blfConfirm,setBlfConfirm]=useState(false)
  const [fieldsData,setFieldsData]=useState(null)
  let dragIndex = -1;
  const ringTypes = [
    { text: "Ring", value: 1 },
    { text: "Silent", value: 2 },
  ];
  const deviceData = props.deviceInfo; // Contains Device information about the Mac Address.
  //  deviceData.nolines_supported = 8;
  // console.dir(deviceData);
  // console.log("AutoDeviceButtons component is loading. ");

  const myForm = useForm({ defaultValues: { dataList: linesDBData } });
  const {
    reset,
    control,
    setValue,
    getValues,
    formState: { dirtyFields, isDirty, errors },
  } = myForm;
  const { fields, append, remove, insert, update, replace, move } =
    useFieldArray({
      control,
      name: "dataList",
    });
 const[updateButtons,setUpdateButtons]=useState(false)
 const[noOfMLALines,setnoOfMLALines]=useState(0);
  useEffect(() => {
    let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    setLoading(true);
    async function fetchData() {
      const [buttons, accountsData, blf_GroupsInfo] =
        await Promise.all([
          provisioningHelper.getButtonsDropDown(siteid),
          provisioningHelper.getAccountUsersList(siteid),
          provisioningHelper.getBlfGroupsInfo(siteid, deviceData.macaddress)

        ]);
      console.log("buttons :" + JSON.stringify(buttons) + " blf_GroupsInfo length: " + blf_GroupsInfo?.length);

      const [linesList, linesMap] = await provisioningHelper.getLinesInfo(siteid, deviceData, blf_GroupsInfo);

      console.log("linesDBList :" + JSON.stringify(linesList));
      const allBlfFields = linesList.filter((field)=>field.button_type == 3 || field.button_type == 10);
      setDefaultRingType(2)
      setDefaultMla(parseInt(linesList[0].no_of_mla_lines))

      const [telephonyUsersList, pbxUsersList] = accountsData;
      //const  = linesDBList;
      // frameBlfData(linesDBList, blf_GroupsInfo);
      setButtonTypes(buttons);
      setTelephonyUsersList(telephonyUsersList);
      setPBXUserList(pbxUsersList);
      setLinesDBData(linesList);
      setLinesDBMap(linesMap);
      setLoading(false);
      setnoOfMLALines(linesList[0]?.no_of_mla_lines)
      setBlf_groups(blf_GroupsInfo);
      console.dir(linesList);
      console.dir(blf_GroupsInfo);
    }
    fetchData();
  }, [cancelChanges,updateButtons]);

  useEffect(() => {
    // Set default values when the API response is received
    if (linesDBData.length > 0) {
      console.log("Resetting values to Default state");
      reset({ dataList: linesDBData });
    }
  }, [linesDBData, reset]);

  useEffect(() => {
    props.setEdited(isDirty);
  }, [isDirty])

  const onSubmit = async function (data) {
    console.dir(dirtyFields);
    console.log("handleSubmit method is called " + data?.dataList.length);
    console.log(data);
    const isNewBLF = data.dataList.filter((item)=>item?.isNewBLF);

    console.log("blf data"+isNewBLF);
    if(isNewBLF.length > 0 && !blfConfirm ){
      setFieldsData(data)
      setBlfPopAlert(true);
      return
    }
    if (dirtyFields?.dataList && dirtyFields.dataList.length > 0) {
      setLoading(true);
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      setDefaultMla(parseInt(data.dataList[0].no_of_mla_lines));
      let jo = {
        deviceData: deviceData,
        list: data,
        dirtyFields: dirtyFields,
        linesMap: linesDBMap,
      };
      const [linesList, linesMap] = await provisioningHelper.saveButtonsData(
        siteid,
        jo,
        blf_groups
      );
      clearDirtyFields();
      setBlfConfirm(false)
      console.log("Lines from DB fetched..." + linesList.length);
      if (linesList.length > 0) {
        setLinesDBData(linesList);
        setLinesDBMap(linesMap);
        setLoading(false);
        setUpdateButtons(!updateButtons)
        setUpdateSuccessMessage("Buttons successfully updated. Please reboot the device.");
        setTimeout(() => {
          setUpdateSuccessMessage(""); // Clear the success message 
        }, 5000);
      }else{     
        setUpdateFailureMessage(true);
        setTimeout(() => {
          setUpdateFailureMessage(false); // Clear the failure message 
          setLoading(false);
        }, 3000);
        reset({ dataList: linesDBData });
        setCancelChanges(!cancelChanges); 
      }
    }
  };

  const onPopSubmit = async function (data) {
    console.dir(dirtyFields);
    console.log(data);
    console.log("handleSubmit method is called " + data?.dataList.length);
    const isNewBLF = data.dataList.filter((item)=>item?.isNewBLF);

    console.log("blf data"+isNewBLF);
   
    if (dirtyFields?.dataList && dirtyFields.dataList.length > 0) {
      setLoading(true);
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      setDefaultMla(parseInt(data.dataList[0].no_of_mla_lines));
      let jo = {
        deviceData: deviceData,
        list: data,
        dirtyFields: dirtyFields,
        linesMap: linesDBMap,
      };
      const [linesList, linesMap] = await provisioningHelper.saveButtonsData(
        siteid,
        jo,
        blf_groups
      );
      clearDirtyFields();
      setBlfConfirm(false)
      console.log("Lines from DB fetched..." + linesList.length);
      if (linesList.length > 0) {
        setLinesDBData(linesList);
        setLinesDBMap(linesMap);
        setLoading(false);
        setUpdateButtons(!updateButtons)
        setUpdateSuccessMessage("Buttons successfully updated. Please reboot the device.");
        setTimeout(() => {
          setUpdateSuccessMessage(""); // Clear the success message 
        }, 5000);
      }else{     
        setUpdateFailureMessage(true);
        setTimeout(() => {
          setUpdateFailureMessage(false); // Clear the failure message 
          setLoading(false);
        }, 3000);
        reset({ dataList: linesDBData });
        setCancelChanges(!cancelChanges); 
      }
    }
  };

  const clearDirtyFields = () => {
    console.log("request came to clear Dirty fields");
    setValue("dataList", [], { shouldDirty: false });
  };

  const onCloseChanges = () => {
    console.log(
      "On Close changes Called :::::::reset datalist" +
      JSON.stringify(linesDBData)
    );
    reset({ dataList: linesDBData });
    setCancelChanges(!cancelChanges);
    setBlfConfirm(false)
  };

  const addBlfgroups = (index, insertBlfgroup) => {
    if (index !== undefined && insertBlfgroup.length > 0) {
      console.log(
        "[BLFGroups][addBlfgroups] request  index: " +
        index +
        "  ,Insertion records : " +
        JSON.stringify(insertBlfgroup)
      );

      let dataList = getValues("dataList");

      console.log(
        "[BLFGroups][addBlfgroups] Before removing indexes DataList :"
      );

      console.dir(dataList);

      let indexes = [];

      indexes.push(index);

      for (var idx = index + 1; idx < getValues("dataList").length; idx++) {
        if (insertBlfgroup.length == indexes.length) {
          console.log("broken loop insertBlfgroup.length == indexes.length");
          break;
        }
        if (getValues("dataList")[idx].button_type == 6) {
          console.log("idx::::" + idx);
          indexes.push(idx);
        }
      }

      console.log("removing indexes" + indexes);
      remove(indexes);

      console.log("[BLFGroups] After removing ");
      console.dir(getValues("dataList"));

      console.log("[BLFGroups] insert operation");
      insertBlfgroup = insertBlfgroup.map((item, i) => {
        return { ...item, button_no: index + i + 1, index: index + i,ring_type:defaultRingType };
      });
      console.log(JSON.stringify(insertBlfgroup));
      insert(index, insertBlfgroup);
      let updatedList = getValues("dataList").map((item) =>
        (item.button_type === 3 || item.button_type === 10)
          ? { ...item, ring_type: 2,isNewBLF:true,ring_type_change:1}
          : item
      );
      setValue("dataList", updatedList);

      console.log("[BLFGroups] After insert at index values :::::::");
      console.dir(getValues("dataList"));
    }
  };
  const onClosePopup = () => {
    setLoadPopup({});
  };

  const removeTemplate = (index) => {
    try {
      console.log("removeTemplate : " + index);
      // If this is BLF group index then remove all the BLF Buttons particular to that group.
      // If this is MLA associated line then remove MLA lines too.
      let buttonInfo = getValues(`dataList[${index}]`);

      let linesToRemove = 1;
      if (buttonInfo?.no_of_mla_lines * 1 > 0) {
        linesToRemove = buttonInfo?.no_of_mla_lines * 1;
      } else if (buttonInfo?.blf_group_id && buttonInfo.blf_group_id > 0) {
        let removeLineIndexes = getValues(`dataList`).map((item, idx) => (item.blf_group_id == buttonInfo.blf_group_id ? idx : null)).filter((idx) => idx !== null);
        linesToRemove = removeLineIndexes.length;
      }
      for (var i = 0; i < linesToRemove; i++) {
        update(index + i, {
          button_no: index + i + 1,
          button_type: 6,
          user_or_value: "",
          user_value_name: "",
          label: "",
          no_of_mla_lines: 0,
          ring_type: 1,
          index: index + i,
        });
      }

      autoFillOperation();
    } catch (e) {
      console.log("Error in removeTemplate : " + e);
    }
  };

  const autoFillOperation = () => {
    console.log("IN autoFillOperation");
    let currentBlfGroupsInMac = getblf_GroupsinButtonkeys(); // Assuming getblf_redGroups() returns an array
    for (let i = 0; i < currentBlfGroupsInMac.length; i++) {
      let groupid = currentBlfGroupsInMac[i];
      let cur_blf_group = getValues(`dataList`).filter(button => (groupid * 1 == button.blf_group_id * 1));
      let isAutoFilled = autoFill_BlfUsers(cur_blf_group, groupid);
    }
  };

  const getblf_GroupsinButtonkeys = () => {
    let uniqueBlf_groups = [];
    let extract_groups = getValues("dataList").filter(button => button.blf_group_id * 1 > 0); // Changed blf_dagerFields to blf_dangerFields and used strict equality operator (===)
    extract_groups.forEach((element) => {
      if (!uniqueBlf_groups.includes(element.blf_group_id)) { // Check if the key already exists
        uniqueBlf_groups.push(element.blf_group_id); // Used set method of Map to set key-value pairs
      }
    });
    console.log("BLF Error Groups in Button keys : " + JSON.stringify(uniqueBlf_groups)); // Converted Map to Object before stringifying
    return uniqueBlf_groups;
  };

  const autoFill_BlfUsers = (btn_conf_blfgrp, btn_groupid) => {

    try {

      console.log("[autoFill_BlfUsers] btn_groupid : " + btn_groupid + " configured blfGroup length :" + btn_conf_blfgrp.length);

      let db_groupInfo = blf_groups[btn_groupid];  //global access variable

      if (db_groupInfo.length == btn_conf_blfgrp.length) {
        console.log("[autoFill_BlfUsers] from db  db_groupInfo  :" + db_groupInfo.length + " ,btn_conf_blfgrp :" + btn_conf_blfgrp.lenth + " for groupid :" + btn_groupid);
        return;
      }

      let buttonsList = getValues("dataList");

      let notConfiguredUsers = db_groupInfo.filter(item => {
        if (!buttonsList.find(bt_item => (bt_item.button_type != 5 && bt_item.user_or_value * 1 == item.user_or_value * 1))) {
          return item;
        }
      });

      if (notConfiguredUsers.length == 0) {
        return;
      }

      console.log("[autoFill_BlfUsers] Not configured users :" + notConfiguredUsers);

      let blf_last_idx = btn_conf_blfgrp[btn_conf_blfgrp.length - 1].index * 1;

      let emptyIndexes = [];

      for (let i = blf_last_idx; i < buttonsList.length; i++) {
        if (buttonsList[i].button_type == 6) {
          emptyIndexes.push(i);
        }
      }

      console.log("[autoFill_BlfUsers]emptyIndexes :" + JSON.stringify(emptyIndexes));

      let isdangerExist = notConfiguredUsers.length > emptyIndexes.length ? true : false;

      if (emptyIndexes.length == 0) {
        console.log("[autoFill_BlfUsers] Currently No EmptyLines to fill new users , emptyLines :" + emptyIndexes.length);
      } else {
        insert_NotConfiguredUsers(notConfiguredUsers, emptyIndexes, blf_last_idx);
      }

      let dataList = getValues("dataList").map((field, index) => {
        let jo = {};
        if (field.blf_group_id * 1 == btn_groupid * 1) {
          if (isdangerExist) {
            jo = { ...field, button_no: index + 1, index: index, blf_error: 1 };
          } else {
            jo = { ...field, button_no: index + 1, index: index, blf_error: 0 };
          }
        } else {
          jo = { ...field, button_no: index + 1, index: index };
        }
        return jo;
        //update(index, jo);
      });
      console.log("final Update:::::::::::");
      console.dir(dataList);
      replace(dataList);
    } catch (e) {
      console.error("Error in autoFill_BlfUsers" + e);
    }
  }

  const insert_NotConfiguredUsers = (notConfiguredUsers, emptyIndexes, last_blf_idx) => {
    try {
      let positionToinsert = last_blf_idx;
      console.log("[autoFill_BlfUsers] safe we are good to update :notConfiguredUsers.length : " + notConfiguredUsers.length + " emptyIndexes length :" + emptyIndexes);
      let insertUSers = [];
      if (notConfiguredUsers.length > emptyIndexes.length) {
        insertUSers = notConfiguredUsers.slice(0, emptyIndexes.length)
      } else {
        insertUSers = notConfiguredUsers;
      }

      let removeEmptyLines = [];
      for (let ind = 0; ind < insertUSers.length; ind++) {
        removeEmptyLines.push(emptyIndexes[ind]);     //we need emptyLines 
      }
      console.log("[autoFill_BlfUsers] removeEmptyLines :" + removeEmptyLines.length);
      remove(removeEmptyLines);
      console.log("[autoFill_BlfUsers] After removing empty lines :");
      console.dir(getValues("dataList"));
      console.log("[autoFill_BlfUsers] insertUSers :" + JSON.stringify(insertUSers));
      insert(positionToinsert + 1, insertUSers);
      console.dir(getValues("dataList"));

    } catch (e) {
      console.error("[autoFill_BlfUsers][insert_NotConfiguredUsers] Error while making safe insert" + e);
    }
  }


  const getDnDSourceDestinationIndex = (map, dragorDropIndex, type) => {
    var actualDragorDropIndex = 0;
    // type = 1 means top-down DND & type = 2 means down-top DND & type =3 means source drag.

    let mapEntries = map.entries();
    // Iterating over the entries
    var index = 0;
    for (let entry of mapEntries) {
      if (index === dragorDropIndex) {
        var arr = entry[1];
        if (arr.length > 1 && type == 1) {
          actualDragorDropIndex = arr[arr.length - 1];
        } else if (arr.length <= 1 || type == 2 || type == 3) {
          actualDragorDropIndex = arr[0];
        }
        break;
      }
      index++;
      //console.log(entry[0], entry[1]);
    }

    return actualDragorDropIndex;
  }

  const getFieldsMap = () => {
    var map = new Map();
    var list = getValues("dataList");
    var previousButton = list[0];
    try {
      map.set(0, [0]);
      var lastIndex = 0;
      for (var i = 1; i < list.length; i++) {
        if (list[i].MLA_DUMMY || (list[i].blf_group_id > 0 && list[i].blf_group_id == previousButton.blf_group_id)) {
          if (map.get(lastIndex) != null) {
            var ar = map.get(lastIndex);
            ar.push(i);
            map.set(lastIndex, ar);
            continue;
          }
        }
        map.set(i, [i]);
        lastIndex = i;
        previousButton = list[i];
      }
      console.log("Map is : " + map);
      console.dir(map);
    } catch (e) {
      console.log("Exception in getFieldsMap: " + e);
    }
    return map;
  }



  const removeDublicateUsers = (dataList, group) => {
    console.log("[removeDublicateUsers] :");
    let filteredBlfgroup = [];
    group.map((grp) => {
      //let user = dataList.filter((data) => (data.buttonType * 1 != 5 && grp.user_or_value == data.user_or_value * 1));
      let user = dataList.find((data) => data.user_or_value * 1 == grp.user_or_value);
      if (!user || (user && user.button_type * 1 == 5)) {
        filteredBlfgroup.push(grp);
      }
    });
    return filteredBlfgroup;
  };

  const handleOnDragEnd = (result) => {
    console.log("handleonDragEnd is called... " + result);
    console.dir(result);
    if (!result.destination) {
      return;
    }

    var list = getValues("dataList");
    const sourceIndex = getDnDSourceDestinationIndex(getFieldsMap(), result.source.index, 3);
    const destinationIndex = getDnDSourceDestinationIndex(getFieldsMap(), result.destination.index, (result.destination.index > result.source.index ? 1 : 2));
    //alert("actual source & destination indexes are : "+sourceIndex+": "+destinationIndex);
    // return;
    if (sourceIndex == 0) {
      return;
    }

    if (destinationIndex == 0) {
      // alert("can't drop here as first button always should be Line.");
      let data = {
        type: "popup",
        title: "Error",
        text: "ButtonsFirstLineError",
        button: "okay",
      };
      setLoadPopup(data);
      return;
    }
    const dataList = getValues("dataList");
    const sourceField = dataList[sourceIndex];
    const destinationField = dataList[destinationIndex];
    if (dataList.length > 0) {
      const mlaLines = dataList[sourceIndex].no_of_mla_lines;
      if (mlaLines > 1) { // Drop MLA Lines currently we can drag and drop only BLA Line.
        let dragList = dataList.filter(
          (field, index) => field.button_ref == sourceField.index
        );
        dragList.unshift(sourceField);
        const removedIndexs = dragList.map((item) => item.index);
        remove(removedIndexs);
        let destIndex = destinationIndex;
        let insertIndex = destIndex;
        if (destinationIndex > sourceIndex) {
          destIndex = destinationIndex - mlaLines + 1;
          insertIndex = destIndex;
        }
        dragList = dragList.map((field, index) => {
          let jo = { ...field, index: destIndex, button_no: destIndex + 1 };
          destIndex += 1;
          return jo;
        });
        insert(insertIndex, dragList);
      } else if (sourceField.hasOwnProperty("blf_group_id") && sourceField.blf_group_id * 1 > 0) { // Drop BLF Group buttons.
        console.log("Dragged field is BLF Group." + JSON.stringify(sourceField));
        console.log(JSON.stringify(blf_groups[sourceField.blf_group_id]));
        const no_of_user_in_blf_group = dataList.filter(
          (field, index) =>
            field.blf_group_id * 1 === sourceField.blf_group_id * 1
        ).length;
        console.log("no_of_user_in_blf_group: " + no_of_user_in_blf_group);
        let destIndex = destinationIndex;

        if (sourceField.blf_group_id > 0 && destinationField.blf_group_id > 0) {

        } else if (destinationIndex > sourceIndex) {
          destIndex = destinationIndex - no_of_user_in_blf_group + 1;
        }
        const removedIndexs = dataList.filter((field, index) => field.blf_group_id * 1 === sourceField.blf_group_id * 1).map((field, index) => field.index);
        var btn_conf_group = dataList.filter(field => field.blf_group_id * 1 === sourceField.blf_group_id * 1);
        console.log("After Removing :::::::::::" + JSON.stringify(removedIndexs) + " removedUsers :" + JSON.stringify(btn_conf_group));
        remove(removedIndexs);
        let tempDestIndex = destIndex;

        // let filterDublicates = removeDublicateUsers(getValues("dataList"), blf_groups[sourceField.blf_group_id]);

        let insertBlfgroup = btn_conf_group.map(
          (item, index) => {
            var jo = {
              ...item,
              button_no: tempDestIndex + index + 1,
              index: tempDestIndex + index,
            };
            return jo;
          }
        );

        console.log("insert BLF group information:::::::::");
        console.log(JSON.stringify(insertBlfgroup));
        insert(destIndex, insertBlfgroup);
        console.dir(getValues("dataList"));
      } else { // Drop single line buttons here.
        move(sourceIndex, destinationIndex);
      }

      // Re-order the MLA buttons references and also button_no & indexes as per List order.
      let mlaIndex = -1;
      getValues("dataList").map((field, index) => {
        // if (field.no_of_mla_lines > 1) {
        let jo = { ...field, button_no: index + 1, index: index };
        if (jo.hasOwnProperty("MLA_DUMMY")) {
          jo.button_ref = mlaIndex;
        } else {
          mlaIndex = index;
        }
        update(index, jo);
      }
        // }
      );

      console.log("after arranging :")
      console.dir(getValues("dataList"));





      // if (sourceField.hasOwnProperty("blf_group_id") && sourceField.blf_group_id * 1 > 0) {
      //   autoFill_BlfUsers(btn_conf_group, sourceField.blf_group_id);
      // }
      autoFillOperation();
    }
  };



  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: isDragging ? "none" : "auto",
    ...draggableStyle,
  });

  return (
    <React.Fragment>
      <>
        {!loading && fields.length > 0 && (
          <DragDropContext
            onDragEnd={handleOnDragEnd}
            className="w-100 dragItem"
          >
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  className="pb-5"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <MDBTable className="font-size-12 overflow-x ">
                    <MDBTableHead>
                      <LoadHeaderTemplate />
                    </MDBTableHead>
                    <MDBTableBody>
                      <FormProvider {...myForm}>
                        {pbxUsersList.length > 0 &&
                          telephonyUsersList.length > 0 &&
                          linesDBData.length > 0 && (
                            <AutoDeviceButtonContext.Provider
                              value={{
                                deviceData: deviceData,
                                buttonTypes: buttonTypes,
                                ringTypes: ringTypes,
                                pbxUsersList: pbxUsersList,
                                telephonyUsersList: telephonyUsersList,
                                linesDBData: linesDBData,
                                blfgroupsInfo: blf_groups,
                                insertFun: function (number, obj) {
                                  insert(number, obj);
                                },
                                removeFun: function (number) {
                                  removeTemplate(number);
                                },
                                updateFun: function (number, obj) {
                                  update(number, obj);
                                },
                                addBlf: function (index, records) {
                                  addBlfgroups(index, records);
                                },
                                togleAlert: function (val) {
                                  setLoadPopup(val);
                                },
                                defaultMlaLines:defaultMla,
                                defualtRing:defaultRingType,
                                setRingTypeDefualt :function(ring){
                                  setDefaultRingType(ring)
                                },
                                setDefault:function(mla){
                                  setDefaultMla(mla)
                                }
                                // deleteBLF: function (index) { deleteBlfGroup(index) }
                              }}
                            >
                              {/* {console.log("UI fields ===>", fields)} */}
                              {fields.map((field, index) => {
                                if (index == 0) {
                                  dragIndex = -1
                                }
                                if (field.no_of_mla_lines > 0 && field.hasOwnProperty("MLA_DUMMY")) {
                                  return null;
                                }

                                if (field?.blf_group_id > 0 && fields[index - 1]?.blf_group_id === field?.blf_group_id) {
                                  return null;
                                }
                                dragIndex = dragIndex + 1;
                                field.index = index;
                                switch (field.button_type) {
                                  case 1:
                                  case 2:
                                    return (
                                      <Draggable
                                        key={field.id}
                                        draggableId={field.id}
                                        index={dragIndex}
                                        isDragDisabled={field.button_type == 1}
                                      >
                                        {(provided, snapshot) => (
                                          <LoadMLATemplate
                                            key={field.id}
                                            buttonNo={field.button_no}
                                            buttonInfo={field}
                                            id={field.id}
                                            index={index}
                                            rem={remove}
                                            provided={provided}
                                            fields={fields}
                                            noOfMLALines={noOfMLALines}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          />
                                        )}
                                      </Draggable>
                                    );

                                  case 3:
                                    return (
                                      <Draggable
                                        key={field.id}
                                        draggableId={field.id}
                                        index={dragIndex}
                                        isDragDisabled={false}
                                      >
                                        {(provided) => (
                                          <LoadBLFTemplate
                                            key={field.id}
                                            buttonNo={field.button_no}
                                            buttonInfo={field}
                                            id={field.id}
                                            index={index}
                                            rem={remove}
                                            provided={provided}
                                            fields={fields}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          />
                                        )}
                                      </Draggable>
                                    );

                                  case 4:
                                    return (
                                      <Draggable
                                        key={field.id}
                                        draggableId={field.id}
                                        index={dragIndex}
                                        isDragDisabled={false}
                                      >
                                        {(provided) => (
                                          <LoadParkTemplate
                                            key={field.id}
                                            buttonNo={field.button_no}
                                            buttonInfo={field}
                                            id={field.id}
                                            index={index}
                                            rem={remove}
                                            provided={provided}
                                            fields={fields}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          />
                                        )}
                                      </Draggable>
                                    );
                                  case 5:
                                    return (
                                      <Draggable
                                        key={field.id}
                                        draggableId={field.id}
                                        index={dragIndex}
                                        isDragDisabled={false}
                                      >
                                        {(provided) => (
                                          <LoadSpeedDialTemplate
                                            key={field.id}
                                            buttonNo={field.button_no}
                                            buttonInfo={field}
                                            id={field.id}
                                            index={index}
                                            rem={remove}
                                            provided={provided}
                                            fields={fields}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          />
                                        )}
                                      </Draggable>
                                    );
                                  case 6:
                                  case undefined:
                                    return (
                                      <Draggable
                                        key={field.id}
                                        draggableId={field.id}
                                        index={dragIndex}
                                        isDragDisabled={false}
                                      >
                                        {(provided) => (
                                          <LoadBlankTemplate
                                            key={field.id}
                                            buttonNo={field.button_no}
                                            buttonInfo={field}
                                            id={field.id}
                                            index={index}
                                            rem={remove}
                                            provided={provided}
                                            fields={fields}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          />
                                        )}
                                      </Draggable>
                                    );
                                  case 10:
                                    return (
                                      <Draggable
                                        key={field.id}
                                        draggableId={field.id}
                                        index={dragIndex}
                                        isDragDisabled={false}
                                      >
                                        {(provided) => (
                                          <LoadBLFGroupsTemplate
                                            key={field.id}
                                            buttonNo={field.button_no}
                                            buttonInfo={field}
                                            id={field.id}
                                            index={index}
                                            rem={remove}
                                            provided={provided}
                                            fields={fields}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          />
                                        )}
                                      </Draggable>
                                    );
                                }
                              })}
                              {/* <input
                          type="button"
                          value="Submit"
                          onClick={
                            myForm.handleSubmit(onSubmit)
                          }
                        /> */}
                              {updatesuccessMessage && (
                                <MDBAlert
                                  open
                                  className="alert-center"
                                  color="success"
                                  autohide
                                  position="bottom-right"
                                  delay={10000}
                                >
                                  <i className="fas fa-check-circle me-3"></i>
                                  <span className="alert-msg">{updatesuccessMessage}</span>
                                </MDBAlert>
                              )}
                              {isDirty && (
                                <SaveChanges
                                  onClose={onCloseChanges}
                                  onSave={(e) => {
                                    e.preventDefault();
                                    if (Object.keys(errors).length === 0) { // Check if there are no validation errors
                                      myForm.handleSubmit(onSubmit)();
                                    }
                                  }}
                                  isDisabled={Object.keys(errors).length > 0} // Pass disable state as prop
                                />
                              )}
                            </AutoDeviceButtonContext.Provider>
                          )}
                      </FormProvider>
                    </MDBTableBody>
                  </MDBTable>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}
        {loading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}
        {
          blfPopUpAlert && <>
            <PopupLoader
              title="Alert"
              content={
                <>
                  <div className="d-flex align-items-center bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                    <MDBIcon fas icon="ban" className="me-3" size="lg" color="warning" />
                    <span>
                     Ring Type for BLF is a global parameter. The ring type set for last BLF line will be applied for all BLF lines configured on this MAC. Do you want to continue?
                    </span>
                  </div>

                  <MDBModalFooter className="p-0 mt-3 pt-2">
                    <MDBBtn color="secondary" className="cancle-btn" onClick={()=>{
                      onCloseChanges()
                      setBlfPopAlert(false)}}>
                      {t("close")}
                    </MDBBtn>
                    <MDBBtn onClick={()=>{
                      setBlfPopAlert(false)
                      onPopSubmit(fieldsData)}}>
                      {t("confirm")}
                    </MDBBtn>
                  </MDBModalFooter>
                </>
              }
              onClose={()=>setBlfPopAlert(false)}
            />
          </>
        }
        {loadPopup?.type == "popup" && (
          <PopupLoader
            title={t(loadPopup?.title)}
            content={
              <>
                <div className="fs-6 ps-3">{t(loadPopup?.text)}</div>
                <div className="modal-footer p-0 border-0">
                  <button
                    type="button"
                    className="btn green-button"
                    onClick={(e) => {
                      onClosePopup();
                    }}
                  >
                    {t(loadPopup?.button)}
                  </button>
                </div>
              </>
            }
            onClose={(e) => onClosePopup()}
          />
        )}
        {updateFailureMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={100000}
          >
        {t("Provisioning_Error_Aleart")}
          </MDBAlert>
        )}
      </>
      <></>
    </React.Fragment>
  );
}

